import React from 'react';
import { Link } from 'react-router-dom';

const CustomFooter=props=>{
  return (
        <footer className="scfooter">
          <div className="container">
            <div className="row">
              <div className="footer-copyright">
                <p>2017 ~ 2020 © LESOFI ASIA LLP</p>
              </div>
            </div>  
        </div>
        
      </footer>
  )
}

export default CustomFooter;



// WEBPACK FOOTER //
// ./src/components/CustomFooter/CustomFooter.js